import { apiGateway } from '../../api';

/**
 * IP 66
 * Buscar lista de solicitacoes de segunda via de carteirinhas
 * @param {object} param  numeroContrato, dataInicioPeriodo, dataFimPeriodo
 */
export async function getListaSolicitacoes({ numeroContrato, dataInicioPeriodo, dataFimPeriodo }) {
    try {
        const { data } = await apiGateway.get('/carteiras/segunda-via', {
            params: {
                numeroContrato,
                dataInicioPeriodo,
                dataFimPeriodo,
            },
        });
        return data;
    } catch (error) {
        // console.error(error)
        return false;
    }
}

/**
 * IP 63
 * Solicitar segunda via de carteirinhas
 * @param {object} param  Array<{numeroAssociadoOuNumeroCarteira, tipoAssociado, codigoMotivoSegundaVia, codigoTipoCartao, codigoTipoEnderecoCarteira, emitidoPor}>
 */
export async function solicitaSegundaViacarteiras({ segundaViaCarteira }) {
    try {
        const { data } = await apiGateway.post(
            'gerenciador-processos-portais/segunda-via-carteira',
            segundaViaCarteira
        );
        return data;
    } catch (error) {
        return error.response.data;
    }
}
